import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import "./heroVideo.css";
import CustomButton from "../Button/CustomButton";
import { useNavigate } from "react-router-dom";

const HeroVideo = () => {
  const navigate = useNavigate();

  const slides = [
    {
      id: "01",
      tag: "Integrated Renewable Energy Advisory",
      bigTitle: "Integrated Renewable Energy Advisory",
      smallTitle: "Finance • Engineering • Execution",
      description: "Supporting renewable energy projects from planning to delivery.",
      video: "https://dazbog.ascentbw.com/Images/Home/01.mp4"
    },
    {
      id: "02",
      tag: "Renewable Energy Advisory Partner",
      bigTitle: "Delivering bankable clean energy solutions",
      smallTitle: "Project Planning & Delivery",
      description: "Helping developers and investors bring projects to life.",
      video: "https://dazbog.ascentbw.com/Images/Home/02.mp4"
    },
    {
      id: "03",
      tag: "End-to-End Renewable Support",
      bigTitle: "From project ideas to execution",
      smallTitle: "Technical & Financial Expertise",
      description: "Supporting solar, BESS, hybrid, and emerging energy projects.",
      video: "https://dazbog.ascentbw.com/Images/Home/03.mp4"
    },
  ];

  return (
    <section className="hero-full-container" id="home">
      <Carousel 
        fade 
        controls={false} 
        indicators={true} 
        interval={4000}
        pause={false}
        className="hero-carousel"
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={index} className="hero-carousel-item">
            {/* Video Background */}
            <div className="video-background-wrapper">
              <video 
                autoPlay 
                muted 
                loop 
                playsInline 
                key={slide.video} 
                className="hero-video-bg"
              >
                <source src={slide.video} type="video/mp4" />
              </video>
              <div className="hero-bg-overlay"></div>
            </div>

            <Container className="hero-content-container">
              <div className="hero-content-wrapper d-flex align-items-lg-end">
                <Row className="w-100 align-items-end gy-4">
                  {/* Left Column: Big Title */}
                  <Col lg={7} md={12} className="text-start">
                    <div className="hero-tag-pill mb-3">
                      {slide.tag}
                    </div>
                    <h1 className="hero-display-title">
                      {slide.bigTitle}
                    </h1>
                  </Col>

                  {/* Right Column: Content & Buttons */}
                  <Col lg={5} md={12} className="ps-lg-5 d-flex flex-column align-items-start">
                    <div className="slide-info-wrapper text-start">
                      <span className="slide-number">{slide.id}</span>
                      <h2 className="slide-small-title">{slide.smallTitle}</h2>
                      <p className="slide-description">
                        {slide.description}
                      </p>
                      
                      <div className="hero-btn-group d-flex gap-3">
                        <CustomButton
                          variant="white"
                          size="md"
                          text="Discuss Your Project"
                          showArrow={false}
                          onClick={() => navigate("/contact")}
                        />
                        <button 
                          className="btn-outline-glass"
                          onClick={() => navigate("/services")}
                        >
                          Explore Services
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
};

export default HeroVideo;
